import * as Yup from "yup";

export const supportReqValidationSchema = (t) =>
  Yup.object().shape({
    firstName: Yup.string().required(t("Please enter first name")),
    lastName: Yup.string().required(t("Please enter last name")),
    emailId: Yup.string().matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      t("Please enter a valid email address")
    ).required(t("Please enter email address")),
    description: Yup.string().required(t("Please enter description")),
  });

export const profileChangeSchema = (t) =>
  Yup.object().shape({
    addressLine1: Yup.string().required(t("Please enter address line 1")),
    city: Yup.string().required(t("Please enter city")),
    zip: Yup.string().required(t("Please enter zip code")),
  });
